import React, { useEffect, useState } from 'react';
import * as  Yup from 'yup';
import PublicHeader from '../Header/PublicHeader';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { ERROR_MSG, handleInputToUppercase, handleKeyAlphaNumeric } from '../CommonUtilities/Validations/RegularExpAndVar';
import { CommonPageHeading } from '../CommonUtilities/CommonHeading/CommonPageHeading';
import { config } from '../CommonUtilities/CommonUrl/CommonUrls';
import axios from 'axios';
import { TfiReload } from 'react-icons/tfi';
import { CommonReactTable } from '../CommonUtilities/CommonTable/CommonReactTable';
export default function PreviousTetResults() {

    const [refreshCaptcha, setRefreshCaptcha] = useState("");
    const handleRefreshCaptcha = () => {
        Formik.setFieldValue('captchaId', "")
        Formik.setFieldValue('captcha', "")
        let url = config.url.DSC_URL + "dsc-public/generate-captcha";
        axios.post(url).then((res) => {
            if (res?.data?.status === true) {
                setRefreshCaptcha(res.data.captcha)
                Formik.setFieldValue('captchaId', res.data.captchaId)
            }
        })
    };

    useEffect(() => { handleRefreshCaptcha() }, [])
    const [showData, setData] = useState([]);
    const [showD1, setD1] = useState();
    const [showErrsg, setErrMsg] = useState("");

    // *******************columns *********************
    const columns = [
        { Header: "S.NO", accessor: (row, index) => index + 1 },
        { Header: "HallTicket No", accessor: "ht_no" },
        { Header: "Candidate Name", accessor: "candidate_name" },
        { Header: "Father Name", accessor: "father_name" },
        { Header: "Subject", accessor: "tet_post_name" },
        { Header: "Year Of Pass", accessor: "yop" },
        { Header: "Score", accessor: "score" },]
    function isBackFunction() {
        setD1(showD1 - 1);
    }
    // *************validations ************************
    const userValidations = Yup.object().shape({
        htNo: Yup.string().required(ERROR_MSG),
        captcha: Yup.string().required(ERROR_MSG),

    });

    const Formik = useFormik({
        initialValues: {
            "htNo": "",
            "captcha": "",
            "captchaId": ""
        },
        validationSchema: userValidations,
        onSubmit: (values, { resetForm }) => {
            //console.log("val>>", values);
            let url = config.url.DSC_URL + "dsc-public/candidate-personal-and-paper-details"
            axios.post(url, values).then((res) => {
                if (res?.data?.status === true) {
                    setData(res?.data?.data);
                    setErrMsg("");
                    // resetForm();
                    // handleRefreshCaptcha();
                }
                else {
                    setData([]);
                    setErrMsg(res?.data?.sdesc);
                    // resetForm();
                    handleRefreshCaptcha();
                }

            })
        }
    })
    return (
        <React.Fragment>
            <PublicHeader />
            <FormikProvider value={Formik}>
                <Form className="form-section mb-4" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange} >
                    <div className='mt-5 px-2 pt-2'>
                        <CommonPageHeading heading='Previous TET Results' back={true} />
                        <Row className="row px-3">
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3">
                                <Form.Group controlId="htNo">
                                    <Form.Label className="input-lable mb-2">
                                        Mobile No/TET Hallticket No <font color="red">*</font>
                                    </Form.Label>
                                    <Field type="text" name="htNo" className="input-field form-control"
                                        maxLength="20"
                                        onKeyPress={(e) => {
                                            handleKeyAlphaNumeric(e);
                                        }}
                                        onInput={(e) => { handleInputToUppercase(e) }}
                                        onChange={(e) => {
                                            Formik.handleChange(e);
                                            if (showData.length > 0 || showD1 === 0) {
                                                Formik.setFieldValue("captcha", "");
                                                Formik.setFieldValue("captchaId", "");
                                                setData([]);
                                                setD1(undefined);
                                                handleRefreshCaptcha();
                                            }
                                        }}
                                    />
                                </Form.Group>
                                <ErrorMessage name="htNo" component="div" className="text-error" />
                            </Col>
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 pt-4">
                                <Form.Group controlId="captcha">
                                    <InputGroup className="mb-2">
                                        <TfiReload onClick={() => { handleRefreshCaptcha() }} size={20} className="mt-1" />&nbsp;
                                        <img height={40} width={100} src={refreshCaptcha} alt="captcha" />&nbsp;&nbsp;
                                        <Field className="form-control" type="text" name="captcha" placeholder="Captcha" maxLength="6" autoComplete="off" />
                                    </InputGroup>
                                </Form.Group>
                                <ErrorMessage name="captcha" component="div" className="text-error" />
                            </Col>
                            <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className="mb-3 pt-4">
                                <Button type="submit" className="btn btn-primary btn-md" onClick={() => { setD1(0) }}>Get Data</Button>
                            </Col>
                        </Row>
                        {showD1 === 0 && (
                            <> {showData?.length > 0 ? (
                                <div className="table-responsive">
                                    <CommonReactTable tableid='selected-id' pagination="false" data={showData} columns={columns}
                                        serachAlign="left" isBack={false}
                                        isBackFunction={isBackFunction}
                                        headerName={<>Previous TET Results</>}
                                        headColumCount={7} search="true" showFooter="false" filename="TetResult"
                                        paginationCount="All" printFalg="false"
                                    /> </div>
                            ) : (
                         <div className="text-error text-center" style={{ fontSize: "15px" }}>{showErrsg}</div>)}</>)}
                    </div>
                </Form>
            </FormikProvider>

        </React.Fragment>
    )
}
